import enumify from './enumify';

export const LOAD_LICENSE_COMPLETED = 'License.loadLicenseCompleted';

export default enumify({ LOAD_LICENSE_COMPLETED });
